const DEFAULT_FALLBACK = 'Ocurrió un error inesperado. Intente de nuevo o contacte a soporte.';

/**
 * Obtiene un mensaje seguro para mostrar al usuario a partir de un error de http()/axios.
 * Nunca usar error.message, error.stack ni el objeto completo en UI.
 */
export function getApiErrorMessage(error, fallback = DEFAULT_FALLBACK) {
    const data = error?.response?.data;

    if (typeof data === 'string' && data.trim())
        return data.trim();

    if (data && typeof data === 'object') {
        const message = data.message ?? data.Message;
        if (typeof message === 'string' && message.trim())
            return message.trim();
    }

    if (typeof error === 'string' && error.trim())
        return error.trim();

    return fallback;
}

export function getApiErrorCode(error, fallback = 'UNEXPECTED') {
    const data = error?.response?.data;
    if (data && typeof data === 'object') {
        const code = data.code ?? data.Code;
        if (typeof code === 'string' && code.trim())
            return code.trim();
    }
    return fallback;
}

export default getApiErrorMessage;
